import { useSelector } from 'react-redux'

import { selectInternalDataRuns } from 'redux/selectors/internal/DataRuns'

export const useInternalDataRuns = () => {
  return useSelector(selectInternalDataRuns)
}
